/* mypka-vergleichslider.js — myPKA, 28.08.2026 (Felix)
 * Ticket 869er1g2f — "ein sinvoller slider ... wo spalte 1 sticky ist und der
 * rest dann in den hintergrund wegslidede"
 *
 * WAS: Die Sektion "Welcher myBuddy Kalender passt zu dir" ist eine Tabelle
 * mit einer Merkmalspalte und zwei Produktspalten. Unterhalb 750 px wird
 * daraus EIN Kalender je Ansicht: oben eine klebende Leiste mit den beiden
 * Kalendernamen als Punkte, darunter die wischbare Karte, darunter beide CTA.
 *
 * DAS PROBLEM, DAS DAS LOEST — und das die Messung nicht gesehen hat:
 * Gestapelt steht "CLASSIC" und "BIO-VEGAN" ganz oben, die Haken stehen weit
 * darunter. Wer bei "Produktvielfalt" ankommt, sieht zwei Zeichen und muss
 * sich erinnern, welche Spalte welche ist. Nichts ist abgeschnitten, es gibt
 * keinen Ueberlauf — und trotzdem ist die Zuordnung weg. Ein Vergleich, bei
 * dem man sich die Spaltennamen merken muss, vergleicht nicht.
 *
 * WARUM JAVASCRIPT UND KEINE LIQUID-AENDERUNG:
 * Der Desktop bleibt konstruktiv unveraendert — oberhalb 749 px laeuft
 * `aufbauen` nie, das Markup ist Zeichen fuer Zeichen das der Sektion.
 * Dieselbe Beweisfuehrung wie in mypka-quizslider.js (869eqzxmm).
 *
 * WARUM KOPIEN UND KEIN VERSCHIEBEN:
 * Der Quiz-Slider verschiebt seine <li> in die Buehne, weil sie dort als
 * Slides GEBRAUCHT werden. Hier ist es umgekehrt: aus DREI Spalten werden
 * ZWEI Karten, jede Zelle wechselt ihren Platz in der Struktur. Verschoebe
 * ich die Zellen, muesste der Abbau eine Tabelle aus Einzelteilen wieder
 * zusammensetzen — und jeder Fehler dabei zerstoert den Auslieferungsstand.
 * Kopiert bleibt die Tabelle vollstaendig und unberuehrt stehen; sie wird nur
 * ausgeblendet. Der Abbau ist damit ein Entfernen EINES Knotens plus vier
 * zurueckgesetzter Attribute, und er kann nicht halb gelingen.
 * Preis: die zwei Produktbilder stehen zweimal im DOM. Kein zweiter Download
 * (gleiche URL, gleicher Cache), und die Originale liegen in einem
 * `display: none`-Zweig, laden dort also gar nicht erst.
 *
 * WARUM DIE PUNKTE DIE NAMEN TRAGEN:
 * AC-03 verlangt, dass der Name des aktiven Kalenders an jeder Scrollposition
 * lesbar ist. Ein klebender Balken mit einem Namen plus eine Punktleiste
 * waeren zwei Anzeigen fuer denselben Zustand. Die Punkte SIND deshalb die
 * Anzeige: "CLASSIC / BIO-VEGAN", der aktive hervorgehoben, die Leiste klebt.
 * Damit erfuellt ein Element AC-03 und AC-04 — und es ist genau die Skizze,
 * die Erdem am 28.08. gewaehlt hat.
 *
 * TASTATUR: kommt aus assets/mypka-slider-tastatur.js (Ticket 869er0z14).
 * Die Punkte tragen `swiper-pagination-bullet` und liegen in einer
 * `.swiper-pagination` — damit greifen Enter, Space, die Pfeiltasten und die
 * Fokusrettung nach dem Neuaufbau der Leiste ohne eine Zeile hier. Genau
 * deshalb ist der Fix dort zentral und nicht in card-slider.js.
 *
 * DER CTA SITZT IN DER KARTE (seit 01.09.2026, Elternticket 869eqz47g):
 * Die am 28.08. bewusst offen gelassene Entscheidung ueber die
 * Kundenfuehrung ist gefallen — sichtbar ist nur der CTA des aktiven
 * Kalenders, er wechselt mit dem Slide (er liegt IM Slide) und steht im
 * mobilen Klon immer im Primaerstil (die Tabelle behaelt am Desktop ihr
 * primary/secondary je Spalte). Der Selbst-Link der aktiven Seite bleibt:
 * er ist der Weg zurueck nach oben zur Kaufbox (Weihuas "springt nach
 * oben", 22.08.).
 */
(() => {
	const UMSCHALTPUNKT = 749;
	const abfrage = window.matchMedia(`(max-width: ${UMSCHALTPUNKT}px)`);

	/* Die Rollen, die waehrend des Slider-Betriebs auf `presentation` stehen.
	 * Grund: mit ausgeblendetem tbody und tfoot bliebe sonst eine Tabelle mit
	 * genau einer Zelle uebrig, die die Sektionsueberschrift traegt — der
	 * Screenreader kuendigt "Tabelle, 1 Zeile, 1 Spalte" an, und dahinter
	 * steht eine Ueberschrift. Die Vergleichssemantik liegt jetzt in den
	 * <dl> der Karten. Der Merker haelt den alten Wert, damit der Abbau ihn
	 * zurueckgibt statt ihn zu raten. */
	const ROLLEN_SEL = ':scope, :scope > thead, :scope > thead > tr, :scope > thead > tr > .mypka-vergleich__ecke';

	const escape = (s) =>
		String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

	const tabellen = (wurzel) =>
		[...(wurzel || document).querySelectorAll('table.mypka-vergleich__tabelle')].filter(
			(t) => t.querySelectorAll(':scope > thead .mypka-vergleich__kopf').length === 2
		);

	const rollenSetzen = (tabelle) => {
		const teile = [tabelle, ...tabelle.querySelectorAll(ROLLEN_SEL.replace(':scope, ', ''))];
		teile.forEach((el) => {
			if (el.dataset.mypkaRolle === undefined) el.dataset.mypkaRolle = el.getAttribute('role') || '';
			el.setAttribute('role', 'presentation');
		});
	};

	const rollenZurueck = (tabelle) => {
		const teile = [tabelle, ...tabelle.querySelectorAll(ROLLEN_SEL.replace(':scope, ', ''))];
		teile.forEach((el) => {
			if (el.dataset.mypkaRolle === undefined) return;
			if (el.dataset.mypkaRolle) el.setAttribute('role', el.dataset.mypkaRolle);
			else el.removeAttribute('role');
			delete el.dataset.mypkaRolle;
		});
	};

	const aufbauen = (tabelle) => {
		if (tabelle.dataset.mypkaVergleichslider === 'an') return;
		if (typeof Swiper === 'undefined') return;

		const koepfe = [...tabelle.querySelectorAll(':scope > thead .mypka-vergleich__kopf')];
		if (koepfe.length !== 2) return;
		const zeilen = [...tabelle.querySelectorAll(':scope > tbody > tr.mypka-vergleich__zeile')];
		if (!zeilen.length) return;

		const namen = koepfe.map((k, i) => {
			const t = k.querySelector('.mypka-vergleich__titel');
			return (t && t.textContent.trim()) || `Variante ${i + 1}`;
		});
		/* Welche Spalte zum gerade geoeffneten Produkt gehoert, weiss die
		 * Sektion selbst (`aria-current="page"` am Spaltenkopf). Der Slider
		 * startet auf dieser Seite — sonst muesste der Kunde erst wischen, um
		 * das zu sehen, was er gerade ansieht. */
		const seiteIndex = Math.max(0, koepfe.findIndex((k) => k.hasAttribute('aria-current')));

		const empfehlung = tabelle.querySelector(':scope > tfoot > tr.mypka-vergleich__zeile--empfehlung');
		const aktion = tabelle.querySelector(':scope > tfoot > tr.mypka-vergleich__zeile--aktion');

		const mobil = document.createElement('tbody');
		mobil.className = 'mypka-vergleich__mobil';
		mobil.setAttribute('role', 'presentation');

		const leiste = document.createElement('div');
		leiste.className = 'mypka-vergleich__leiste';
		const punkte = document.createElement('div');
		punkte.className = 'swiper-pagination mypka-vergleich__punkte';
		leiste.appendChild(punkte);

		const buehne = document.createElement('div');
		buehne.className = 'swiper mypka-vergleich__slider';
		const spur = document.createElement('div');
		spur.className = 'swiper-wrapper';
		buehne.appendChild(spur);

		koepfe.forEach((kopf, i) => {
			const karte = document.createElement('div');
			karte.className = 'swiper-slide mypka-vergleich__karte';

			/* Eine unsichtbare Ueberschrift je Karte. Sichtbar steht der Name
			 * im Punkt darueber; ohne diese Zeile haette die Karte im
			 * Screenreader aber keinen Namen, und "Haken, Haken, Haken" ohne
			 * Kalendername ist genau der Zustand, den dieses Ticket abschafft. */
			const h = document.createElement('h3');
			h.className = 'visually-hidden';
			h.textContent = namen[i];
			karte.appendChild(h);

			const bild = kopf.querySelector('.mypka-vergleich__bild, .mypka-vergleich__bild-leer');
			if (bild) karte.appendChild(bild.cloneNode(true));

			const liste = document.createElement('dl');
			liste.className = 'mypka-vergleich__mliste';
			zeilen.forEach((tr) => {
				const zellen = [...tr.querySelectorAll(':scope > .mypka-vergleich__zelle')];
				if (zellen.length !== 2) return;
				/* Die Zeilenklassen der Tabelle werden WEITERVERWENDET, nicht
				 * nachgebaut: Mindesthoehe, Polster, Unterlinie und die
				 * Ausrichtung von Zeichen und Text haengen daran. Ein eigener
				 * Satz Abstaende waere ein zweites Mass fuer dieselbe Zeile. */
				const paar = document.createElement('div');
				paar.className = tr.className.replace(/\s*mypka-vergleich__zeile--kopf\s*/g, ' ').trim();
				paar.classList.add('mypka-vergleich__mzeile');

				const dt = document.createElement('dt');
				const name = tr.querySelector(':scope > .mypka-vergleich__merkmal-name');
				dt.className = 'mypka-vergleich__merkmal-name';
				dt.innerHTML = name ? name.innerHTML : '';

				const dd = document.createElement('dd');
				dd.className = 'mypka-vergleich__zelle mypka-vergleich__mwert';
				dd.innerHTML = zellen[i].innerHTML;

				paar.append(dt, dd);
				liste.appendChild(paar);
			});
			karte.appendChild(liste);

			if (empfehlung) {
				const z = [...empfehlung.querySelectorAll(':scope > .mypka-vergleich__zelle')];
				if (z[i] && z[i].textContent.trim()) {
					const p = document.createElement('p');
					p.className = 'mypka-vergleich__empfehlung mypka-vergleich__mempfehlung';
					p.innerHTML = z[i].innerHTML;
					karte.appendChild(p);
				}
			}
			/* Der CTA der Spalte kommt IN die Karte (Erdem, 01.09.): er slidet
			 * damit mit dem aktiven Kalender. Der Klon wird auf den Primaerstil
			 * gestellt — die Original-Tabelle (Desktop) behaelt ihr
			 * primary/secondary je Spalte unveraendert, geaendert wird nur die
			 * mobile Kopie. `custom-hover` gehoert zum Primaerstil des
			 * Button-Snippets (snippets/button.liquid) und kommt mit. */
			if (aktion) {
				const az = [...aktion.querySelectorAll(':scope > .mypka-vergleich__spalten-aktion')];
				if (az[i] && az[i].textContent.trim()) {
					const zelle = document.createElement('div');
					zelle.className = 'mypka-vergleich__maktion-zelle';
					zelle.innerHTML = az[i].innerHTML;
					zelle.querySelectorAll('.button--secondary').forEach((b) => {
						b.classList.remove('button--secondary');
						b.classList.add('button--primary');
						const w = b.closest('.button_wrapper');
						if (w) w.classList.add('custom-hover');
					});
					karte.appendChild(zelle);
				}
			}
			spur.appendChild(karte);
		});

		mobil.append(leiste, buehne);

		/* Wisch-Hinweis unter der Karte (Erdem, 01.09., abgesegnetes Preview):
		 * "Zum Wechseln wischen" mit dem Chevron aus snippets/icon-arrow.liquid
		 * (dieselbe Ikone wie die Slider-Pfeile), links per CSS gespiegelt.
		 * Rein dekorativ (aria-hidden): die bedienbare, beschriftete
		 * Umschaltung sind die Tabs darueber — ein zweiter Hinweis im
		 * Screenreader waere Doppelansage ohne Mehrwert. */
		const chevron = '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg"><path d="M17.0254 26.9492L16 25.9239L21.9492 19.9746L16 14.0254L17.0254 13L24 19.9746L17.0254 26.9492Z" fill="currentColor"/></svg>';
		const hinweis = document.createElement('div');
		hinweis.className = 'mypka-vergleich__wischhinweis';
		hinweis.setAttribute('aria-hidden', 'true');
		hinweis.innerHTML = chevron + '<span>Zum Wechseln wischen</span>' + chevron;
		mobil.appendChild(hinweis);

		const thead = tabelle.querySelector(':scope > thead');
		thead.insertAdjacentElement('afterend', mobil);

		/* Erst JETZT die Marke setzen: das gesamte Ausblenden der Tabellenteile
		 * haengt im CSS an ihr. Bricht der Aufbau vorher ab (kein Swiper, keine
		 * Zeilen), bleibt die gestapelte Fassung stehen — ein Slider, der nicht
		 * kommt, darf den Inhalt nicht mitnehmen. */
		tabelle.dataset.mypkaVergleichslider = 'an';
		rollenSetzen(tabelle);

		tabelle.mypkaTeile = { mobil };
		tabelle.mypkaSwiper = new Swiper(buehne, {
			slidesPerView: 1,
			spaceBetween: 16,
			loop: false,
			speed: 400,
			autoHeight: true,
			initialSlide: seiteIndex,
			a11y: {
				enabled: true,
				slideRole: 'group',
				slideLabelMessage: '{{index}} von {{slidesLength}}',
				firstSlideMessage: 'Erster Kalender',
				lastSlideMessage: 'Letzter Kalender',
			},
			pagination: {
				el: punkte,
				clickable: true,
				type: 'custom',
				renderCustom: (swiper, current, total) => {
					let out = '';
					for (let i = 0; i < total; i += 1) {
						const aktiv = i === current - 1;
						const name = escape(namen[i] || `Variante ${i + 1}`);
						out +=
							`<span class="swiper-pagination-bullet mypka-vergleich__punkt` +
							`${aktiv ? ' swiper-pagination-bullet-active' : ''}` +
							`${i === seiteIndex ? ' mypka-vergleich__punkt--seite' : ''}"` +
							` tabindex="0" role="button"` +
							`${aktiv ? ' aria-current="true"' : ''}` +
							` aria-label="${name} anzeigen">` +
							`<span class="mypka-vergleich__punkt-text">${name}</span>` +
							`</span>`;
					}
					return out;
				},
			},
		});
	};

	const abbauen = (tabelle) => {
		if (tabelle.dataset.mypkaVergleichslider !== 'an') return;
		if (tabelle.mypkaSwiper) {
			tabelle.mypkaSwiper.destroy(true, true);
			tabelle.mypkaSwiper = null;
		}
		const teile = tabelle.mypkaTeile || {};
		if (teile.mobil && teile.mobil.parentNode) teile.mobil.remove();
		delete tabelle.mypkaTeile;
		delete tabelle.dataset.mypkaVergleichslider;
		rollenZurueck(tabelle);
	};

	const anwenden = (wurzel) => {
		tabellen(wurzel).forEach((t) => (abfrage.matches ? aufbauen(t) : abbauen(t)));
	};

	anwenden(document);
	abfrage.addEventListener('change', () => anwenden(document));
	document.addEventListener('shopify:section:load', (event) => anwenden(event.target));
})();
